"use client";
import { SideRailComponentProps } from "@/monarch/rules/programRedesignTraffic/types";
import useProgramRedesignTraffic from "@/monarch/rules/programRedesignTraffic/useProgramRedesignTraffic";
import renderSideRailContent from "./renderSideRailContent";
import { extractComponentNames } from "@/utils/getSortedComponentsBySectionOrder";
import { ComponentListProps } from "./types";

export default function FullSizeContent({ componentList }: ComponentListProps) {
  const { sideRailHeaderComponents, sideRailBodyComponents } =
    useProgramRedesignTraffic();
  const defaultSideRailHeaderComponents: SideRailComponentProps[] = [
    { component: "sideRailTitle" },
    { component: "videoPlayer" },
    { component: "rating" },
  ];
  const headerComponents =
    sideRailHeaderComponents ?? defaultSideRailHeaderComponents;

  const defaulSideRailBodyComponents: SideRailComponentProps[] = [
    { component: "pricing" },
    { component: "ctaButton" },
    { component: "programSkills" },
    { component: "programCourses" },
    { component: "imageTitle" },
    { component: "endorsements" },
    { component: "industryInsights" },
    { component: "partnerLogo" },
  ];
  const bodyComponents = sideRailBodyComponents ?? defaulSideRailBodyComponents;

  return renderSideRailContent({
    components: componentList,
    headerComponentsOrder: extractComponentNames(headerComponents),
    bodyComponentsOrder: extractComponentNames(bodyComponents),
  });
}
